
export default function NewsHero() {
  return (
    <section 
      className="relative py-32 bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('https://readdy.ai/api/search-image?query=Music%20news%20and%20media%20background%20with%20newspapers%2C%20magazines%2C%20and%20digital%20screens%20showing%20music%20content%2C%20professional%20journalism%20environment%2C%20modern%20media%20workspace%20with%20warm%20lighting%2C%20clean%20organized%20setup&width=1920&height=600&seq=news-hero&orientation=landscape')`
      }}
    >
      <div className="container mx-auto px-6 text-center text-white">
        <h1 className="text-5xl md:text-6xl font-bold mb-6">News</h1>
        <p className="text-xl md:text-2xl max-w-3xl mx-auto leading-relaxed">
          最新のリリース情報、ライブ情報、メディア出演など、<br />
          すべてのニュースをお届けします。
        </p>
      </div>
    </section>
  );
}
